import React, { Component } from 'react';

export default class Impressum extends Component {
  render() {
    return(
      <div className="container">
        <h1 className="effect">Impressum</h1>
        <div className="container card">
          <h2>Horfex Pflasterungen GmbH</h2>
          <p>Firmenbuchnummer 290286t<br />
          Rossgrabenweg 2, 9065 Ebenthal, Österreich <br />
          Tel: 0664/3251907<br />
          Fax: 0463/265526-3694<br />
          e-mail: office@horfex.at<br />
          Umsatzsteuer-Identifikationsnummer: ATU 63401606</p>
          <h2>Konzept, Layout und Umsetzung</h2>
          <p>design in time werbeagentur e.U.</p>
          <h2>Bildbearbeitung</h2>
          <p>design in time werbeagentur e.U.</p>
          <h2>Portalbetreiber</h2>
          <p>Weboffice IT Service u. Marketing GmbH & Co KG</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/impressum.js